import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: 480,
    maxHeight: "calc(100vh - 48px)",
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 24px rgba(37, 56, 88, 0.12)",
    outline: "none",
    direction: "rtl",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    height: 56,
    gap: 10,
    padding: "16px 24px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    flex: 1,
    margin: 0,
  },
  closeButton: {
    flexShrink: 0,
    padding: 0,
    width: 24,
    height: 24,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: 24,
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
  },
  label: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: "140%",
    textAlign: "right",
    color: theme.palette.text.primary,
    margin: 0,
  },
  uploadedSection: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  fileRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 0",
  },
  deleteButton: {
    flexShrink: 0,
    padding: 0,
    width: 24,
    height: 24,
    color: theme.palette.text.primary,
    "& svg": { width: 18, height: 18 },
  },
  fileName: {
    flex: 1,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
  },
  pdfIcon: {
    flexShrink: 0,
    width: 22,
    height: 23,
  },
  dropzone: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    minHeight: 160,
    padding: 24,
    boxSizing: "border-box",
    borderRadius: 4,
    border: `1px dashed ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    cursor: "pointer",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
  },
  dropzoneIcon: {
    width: 24,
    height: 24,
    color: theme.palette.text.disabled,
  },
  dropzoneLabel: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "center",
    margin: 0,
  },
  dropzoneHint: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 11,
    lineHeight: "140%",
    color: theme.palette.text.disabled,
    textAlign: "center",
    margin: 0,
  },
  errorText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 11,
    lineHeight: "140%",
    color: theme.palette.error.main,
    textAlign: "right",
    margin: 0,
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    height: 68,
    gap: 12,
    padding: "16px 24px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
  },
  cancelButton: {
    height: 36,
    padding: "15px 28px",
    borderRadius: 4,
    border: `1px solid ${theme.palette.text.primary}`,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      borderColor: theme.palette.text.primary,
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  addButton: {
    height: 36,
    padding: "15px 28px",
    borderRadius: 4,
    border: `1px solid ${theme.palette.primary.main}`,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: `${theme.palette.divider} !important`,
      borderColor: theme.palette.divider,
      color: `${theme.palette.text.disabled} !important`,
    },
  },
}));
